import { ILink } from '@models/ILink';

interface Props {
  readonly title: string;
  readonly links: ILink[];
}

const PopularSearches = ({ title, links }: Props) => (
  <div
    className="col-span-full md:col-span-10 lg:col-span-8"
    data-testid="CT-48-Search-Popular-Searches-Container"
  >
    <p className="body-three pb-1 text-grey-450 lg:pb-3">{title}</p>

    {links
      ?.filter((link, index) => link.name && link.url && index < 4)
      .map(({ name, url, target }, index) => (
        <a
          key={`popular-searches-${name}`}
          href={url}
          target={target}
          className="max-w-[355px]"
          data-testid={`CT-48-Search-Popular-Searches-Link-${index}`}
        >
          <p className="h6 border-black py-1 text-black-100 decoration-1 last:border-b-0 hover:underline lg:py-2">
            {name}
          </p>
        </a>
      ))}
  </div>
);

export default PopularSearches;
